const JIO_SAAVAN_BASE_URL = "https://saavn.dev/api";

const ENDPOINT_JIO_SAAVAN = {
    SEARCH_SINGLE : `${JIO_SAAVAN_BASE_URL}/search`,
    TRACK_INFO : `${JIO_SAAVAN_BASE_URL}/songs`,
    SEARCH_MULTIPLE : `${JIO_SAAVAN_BASE_URL}/search/songs`,
    ALBUMS : `${JIO_SAAVAN_BASE_URL}/albums`,
    ARTISTS : `${JIO_SAAVAN_BASE_URL}/artists`,
}

export default {JIO_SAAVAN_BASE_URL,ENDPOINT_JIO_SAAVAN}